{
    "ShowHeaderRowLabel": "Show Header Row:",
    "ShowFooterRowLabel": "Show Footer Row:",
    "ShowContentRowsLabel": "Show Content Rows:",
    "ShowSpacerRowsLabel": "Show Spacer Row(s):",
    "NAME": "ReportContentRowsSettingsLanguage"
}